import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadInvestmentObjectives,
  loadInvestmentObjectivesFailure,
  loadInvestmentObjectivesSuccess,
} from './investment-objectives.actions';

@Injectable()
export class InvestmentObjectivesEffects {
  private actions$ = inject(Actions);
  private referenceService = inject(ReferenceService);

  constructor() {}

  loadInvestmentObjectives$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadInvestmentObjectives),
      switchMap(() =>
        this.referenceService.referenceSasSecLookupGetInvestmentObjectivesGet().pipe(
          map((response) =>
            loadInvestmentObjectivesSuccess({
              investmentObjectives: response.result || [],
            }),
          ),
          catchError((error) => of(loadInvestmentObjectivesFailure({ error }))),
        ),
      ),
    ),
  );
}
